(() => {
  if (window.luppoNavigationReady) return;
  window.luppoNavigationReady = true;
  let opener;
  const dialog = () => document.getElementById('lp-navigation');
  function selectTab(name, focus = false) {
    const host = dialog();
    if (!host) return;
    host.querySelectorAll('[data-lp-tab]').forEach(tab => {
      const active = tab.dataset.lpTab === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    host.querySelectorAll('[data-lp-features]').forEach(group => { group.hidden = group.dataset.lpFeatures !== name; });
    host.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== 'lp-panel-' + name; });
  }
  function reset() {
    document.documentElement.classList.remove('lp-navigation-open');
    document.querySelectorAll('[data-lp-menu]').forEach(el => el.setAttribute('aria-expanded','false'));
    if (opener?.isConnected) opener.focus({preventScroll:true});
  }
  function bind() {
    const host=dialog();
    if (!host || host.dataset.bound) return;
    host.dataset.bound='true';
    host.addEventListener('close',reset);
    host.addEventListener('click',e=>{
      if(e.target !== host) return;
      const r=host.getBoundingClientRect();
      if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) host.close();
    });
  }
  document.addEventListener('click',e=>{
    if (!(e.target instanceof Element)) return;
    const trigger=e.target.closest('[data-lp-menu]');
    if(trigger){
      const host=dialog(); if(!host) return;
      bind(); opener=trigger;
      selectTab(trigger.dataset.lpMenu);
      if(!host.open) host.showModal();
      host.scrollTop=0;
      document.documentElement.classList.add('lp-navigation-open');
      document.querySelectorAll('[data-lp-menu]').forEach(el=>el.setAttribute('aria-expanded',String(el===trigger)));
      host.querySelector('[data-lp-menu-close]')?.focus();
    }
    const tab=e.target.closest('[data-lp-tab]');
    if(tab) selectTab(tab.dataset.lpTab);
    if(e.target.closest('[data-lp-menu-close]') || e.target.closest('#lp-navigation a')) dialog()?.close();
  });
  document.addEventListener('keydown',e=>{
    if(!e.target.matches?.('[data-lp-tab]')) return;
    if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){
      e.preventDefault();
      const next=e.key==='Home'?'women':e.key==='End'?'men':e.target.dataset.lpTab==='women'?'men':'women';
      selectTab(next,true);
    }
  });
  document.addEventListener('shopify:section:load',bind);
  document.addEventListener('shopify:section:unload',e=>{if(e.target.querySelector('#lp-navigation')) reset();});
  bind();
})();
